import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-fault-fix-not-supported',
    imports: [TranslateModule, CommonModule],
    templateUrl: './fault-fix-not-supported.component.html',
    styleUrl: './fault-fix-not-supported.component.css'
})
export class FaultFixNotSupportedComponent {

  @Input() provider: string;
  @Input() supportedVehicle: boolean = true;
  @Input() supportedProtocol: boolean = true;
}

export interface FaultFixNotSupportedInput {
  provider: string;
  supportedVehicle: boolean;
  supportedProtocol: boolean;
}